import React from 'react';

export default function SignalWavesIcon({ className = "w-6 h-6", animated = true }) {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 64 64" 
      fill="none"
      className={className}
    >
      {/* Center dot (larger) */}
      <circle cx="32" cy="32" r="5" fill="currentColor" opacity="0.8"/>
      <circle cx="32" cy="32" r="3" fill="currentColor"/>
      
      {/* Signal waves - MAXIMIZED to use full space */}
      {/* Inner wave */}
      <path 
        d="M 18 32 A 14 14 0 0 1 32 18" 
        stroke="currentColor" 
        strokeWidth="3.5" 
        fill="none" 
        strokeLinecap="round"
      />
      <path 
        d="M 32 18 A 14 14 0 0 1 46 32" 
        stroke="currentColor" 
        strokeWidth="3.5" 
        fill="none" 
        strokeLinecap="round"
      />
      
      {/* Middle wave */}
      <path 
        d="M 10 32 A 22 22 0 0 1 32 10" 
        stroke="currentColor" 
        strokeWidth="3" 
        fill="none" 
        strokeLinecap="round" 
        opacity="0.7"
      />
      <path 
        d="M 32 10 A 22 22 0 0 1 54 32" 
        stroke="currentColor" 
        strokeWidth="3" 
        fill="none" 
        strokeLinecap="round" 
        opacity="0.7"
      />
      
      {/* Outer wave - FULL SIZE */}
      <path 
        d="M 4 32 A 28 28 0 0 1 32 4" 
        stroke="currentColor" 
        strokeWidth="2.5" 
        fill="none" 
        strokeLinecap="round" 
        opacity="0.4"
      />
      <path 
        d="M 32 4 A 28 28 0 0 1 60 32" 
        stroke="currentColor" 
        strokeWidth="2.5" 
        fill="none" 
        strokeLinecap="round" 
        opacity="0.4"
      />
      
      {/* Pulse animation - only if animated prop is true */}
      {animated && (
        <circle cx="32" cy="32" r="5" fill="none" stroke="currentColor" strokeWidth="2">
          <animate attributeName="r" from="5" to="24" dur="2s" repeatCount="indefinite"/>
          <animate attributeName="opacity" from="0.8" to="0" dur="2s" repeatCount="indefinite"/>
        </circle>
      )}
    </svg>
  );
}
